<template>
  <VContainer class="py-10">
    <h1 class="font-bold text-xl mb-8">{{ $t('Register') }}</h1>
    <FormsRegister @success="goToLogin"></FormsRegister>
    <NuxtLink :to="localePath('/login')">
      {{ $t('Already have an account?') }} {{ $t('Login') }}
    </NuxtLink>
  </VContainer>
</template>

<script lang="ts" setup>
import FormsRegister from '~/components/Forms/Register.vue';

const localePath = useLocalePath();
const router = useRouter();
const { t } = useI18n();

const goToLogin = () => {
  router.push(localePath('/login'));
};

useSeoMeta({ title: t('Register') });
</script>
